import { useMemo, useState } from 'react';
import { AssignmentsFilter } from '../models';

const createInitialAssignmentsFilter = (): AssignmentsFilter => ({});

const getStoredAssignmentsFilter = (initialFilter: AssignmentsFilter): AssignmentsFilter => {
  const raw = localStorage.getItem('assignmentsFilters');
  if (!raw) return initialFilter;
  try {
    const stored = JSON.parse(raw);
    return { ...initialFilter, ...stored };
  } catch {
    return initialFilter;
  }
};

const useAssignmentsFilter = () => {
  const initialFilter: AssignmentsFilter = useMemo(createInitialAssignmentsFilter, []);
  const [filter, setFilter] = useState<AssignmentsFilter>(() =>
    getStoredAssignmentsFilter(initialFilter)
  );

  return {
    initialFilter,
    filter,
    setFilter,
  };
};

export default useAssignmentsFilter; 